var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tags-wrapper card-box"
  }, [_c('router-link', {
    staticClass: "title iconfont icon-biaoqian1",
    attrs: {
      "to": "/tags/",
      "title": "全部标签"
    }
  }, [_vm._v(_vm._s(_vm.length === 'all' ? '全部标签' : '热门标签'))]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_vm._l(_vm.tags, function (item, index) {
    return [_c('router-link', {
      key: index,
      class: {
        active: item.key === _vm.tag
      },
      style: _vm.tagStyleList[index],
      attrs: {
        "to": `/tags/?tag=${encodeURIComponent(item.key)}`
      }
    }, [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('span', {
      key: index + _vm.tags.length
    })];
  }), _vm._v(" "), _vm.length !== 'all' && _vm.tagsData.length > _vm.length ? _c('router-link', {
    attrs: {
      "to": "/tags/"
    }
  }, [_vm._v("更多...")]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };